module.exports = __webpack_public_path__ + "../resources/img/ic_re_navigation_north.614ef39f.svg";